import { useAuth0 } from "@auth0/auth0-react";
import { JSONAPI } from "@certane/arcadia-web-components";
import { Box } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React, { useState } from "react";
import { WorkItemSummaryDto } from "../../../../model/WorkItem";
import bulkUpdateApi, {
  WorkItemBulkUpdateRequest,
} from "../../../../services/api/bulk-updates/workItemBulkUpdates";
import {
  publishToastError,
  publishToastSuccess,
} from "../../../../services/toasts";
import WorkItemUserBulkUpdateForm, {
  WorkItemBulkUpdateFormValues,
} from "./WorkItemBulkUpdateForm";
import WorkItemBulkUpdateResults from "./WorkItemBulkUpdateResults";

const WorkItemBulkUpdate: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] =
    useState<WorkItemBulkUpdateFormValues | null>();
  const [response, setResponse] = useState<JSONAPI<WorkItemSummaryDto[]>>();

  const handleSubmit = async (values: WorkItemBulkUpdateFormValues) => {
    try {
      setLoading(true);

      const accessToken = await getAccessTokenSilently();

      const request: WorkItemBulkUpdateRequest = {
        workItemSearchParameters: {
          types: values.types,
          productIds: values.productIds,
          ownerIds: [values.oldOwnerId],
          states: [
            "NEW",
            "OPEN",
            "EXTERNAL_REVIEW",
            "PENDING_SUBMITTER",
            "PENDING_COUNTERPARTY_SIGNATURE",
            "ON_HOLD",
            "MONITORING",
          ],
          limit: values.limit,
        },
        userId: values.newOwnerId,
        dryRun: values.dryRun,
      };

      const response = await bulkUpdateApi.updateWorkItemUsers(
        request,
        accessToken
      );
      // console.log("response", response);
      setFormValues(values);
      setResponse(response);

      if (!values.dryRun && response.data) {
        publishToastSuccess(
          `${response.data.length} work items updated successfully`
        );
      }
    } catch (e) {
      publishToastError((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <WorkItemUserBulkUpdateForm onSubmit={handleSubmit} />
      {!loading && response && response.data && (
        <Box mt={2}>
          {formValues?.dryRun && (
            <Alert severity={"info"}>
              <strong>{response.data.length}</strong> of{" "}
              <strong>{response.meta.resultCount}</strong> work items will be
              updated.
            </Alert>
          )}
          <WorkItemBulkUpdateResults workItems={response.data} />
        </Box>
      )}
    </>
  );
};

export default WorkItemBulkUpdate;
